export const menu = {
  mainMenu: 'MAIN MENU',
  profile: 'My Profile',
  settings: 'Settings',
  auditLogs: 'Audit Logs',
  operations: 'Operations',
  chargerManagement: 'Charger Management',
  chargerFirmware: 'Charger Firmware',
  firmwareUpdates: 'Firmware Updates',
  vendorManagement: 'Merchant Management',
  kiosk: 'Kiosk',
  vehicleCatalog: 'Vehicle Catalog',
  chargingManagement: 'Charging Management',
  activeSessions: 'Active Sessions',
  chargingHistory: 'Charging History',
  userManagement: 'User Management',
  appAccountDeletion: 'App Account Deletion',
  transactions: 'Transactions',
  appTransactions: 'App Transactions',
  appTopUps: 'Top-Ups',
  rfidTransactions: 'RFID Transactions',
  kioskTransactions: 'Kiosk Transactions',
  kioskSettlements: 'Octopus settlements',
  kioskAlerts: 'Kiosk alerts',
  kioskReleases: 'Kiosk releases',
  kioskReleaseKey: 'Release key',
  kioskGroups: 'Kiosk groups',
  analytics: 'Analytics',
  reports: 'Reports',
  security: 'Security',
  rolesPermissions: 'Roles & Permissions',
  feeManagement: 'Fee Management',
  feeCalculator: 'Fee Calculator',
  pricingViewer: 'Pricing Viewer',
  paymentSettings: 'Payment Settings',
  contentManagement: 'Content Management',
  cronMonitor: 'Task Monitor',
  marketing: 'Marketing',
  notifications: 'Notifications',
  messages: 'Messages',
  banners: 'Banners',
  promotions: 'Promotions & Coupons',
  notificationGroups: 'Notification Groups',
  notificationLogs: 'Notification Logs',
  emailProviderRouting: 'Email Provider Routing',
  logs: 'Logs',
  ocppLogs: 'OCPP Logs',
  aiTroubleshooting: 'AI Troubleshooting',
  reservations: 'Reservations',
  reservationsCalendar: 'Calendar view',
  reservationsList: 'Reservations',
  reservationPolicies: 'Reservation Policies',
  userGroups: 'User Groups',
};